/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * OAuth application info including the secret — returned once on create/regenerate.
 * @export
 * @interface OAuthApplicationWithSecret
 */
export interface OAuthApplicationWithSecret {
    /**
     * 
     * @type {string}
     * @memberof OAuthApplicationWithSecret
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthApplicationWithSecret
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof OAuthApplicationWithSecret
     */
    clientSecret: string;
    /**
     * 
     * @type {Date}
     * @memberof OAuthApplicationWithSecret
     */
    created: Date;
}

/**
 * Check if a given object implements the OAuthApplicationWithSecret interface.
 */
export function instanceOfOAuthApplicationWithSecret(value: object): value is OAuthApplicationWithSecret {
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('clientId' in (value as Record<string, any>)) && !('client_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['clientId'] === undefined && (value as Record<string, any>)['client_id'] === undefined)) return false;
    if ((!('clientSecret' in (value as Record<string, any>)) && !('client_secret' in (value as Record<string, any>))) || ((value as Record<string, any>)['clientSecret'] === undefined && (value as Record<string, any>)['client_secret'] === undefined)) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function OAuthApplicationWithSecretFromJSON(json: any): OAuthApplicationWithSecret {
    return OAuthApplicationWithSecretFromJSONTyped(json, false);
}

export function OAuthApplicationWithSecretFromJSONTyped(json: any, ignoreDiscriminator: boolean): OAuthApplicationWithSecret {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'clientId': json['client_id'],
        'clientSecret': json['client_secret'],
        'created': (new Date(json['created'])),
    };
}

export function OAuthApplicationWithSecretToJSON(json: any): OAuthApplicationWithSecret {
    return OAuthApplicationWithSecretToJSONTyped(json, false);
}

export function OAuthApplicationWithSecretToJSONTyped(value?: OAuthApplicationWithSecret | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'client_id': value['clientId'],
        'client_secret': value['clientSecret'],
        'created': value['created'].toISOString(),
    };
}

